<template>
  <div>
    <div class="app" style="position: relative;top: 50%;">
      <div class="wp animsition">
        <div class="boardLogin">
          <p class="logo">覆冰监测平台登录</p>
          <!-- <form> -->
          <div class="inpGroup">
            <div class="ingo">
              <span class="loginIco1" style="margin-top: -3px;"></span>
            </div>
            <!-- <input type="text" name placeholder="请输入您的用户名" /> -->
            <el-input v-model="input1" placeholder="请输入您的用户名" @keyup.enter.native="keyup()"></el-input>
          </div>
          <!-- 
            <div class="prompt">
              <p class="error">用户名错误或不存</p>
            </div>
          -->
          <div class="inpGroup">
            <div class="ingo">
              <span class="loginIco2" style="margin-top: -3px;"></span>
            </div>
            <!-- <input type="password" name placeholder="请输入您的密码"/> -->
            <el-input v-model="input2" placeholder="请输入您的密码" show-password @keyup.enter.native="keyup()"></el-input>
          </div>
          <!-- 
            <div class="prompt">
              <p class="success">输入正确</p>
            </div>
          -->
          <!-- <button class="submit">登录</button> -->
          <!-- <button class="animsition-link submit">登录</button> -->
          <!-- <el-button type="primary" class="animsition-link submit" @click="submitForm()">登录</el-button> -->
          <el-button type="primary" class="animsition-link submit" @click="submitForm()">登录</el-button>
          <!-- <el-button type="text" @click="open">点击打开 Message Box</el-button> -->
          <!-- </form> -->
        </div>
        <!-- 动态设置页面宽度分辨率 -->
        <!-- <el-button type="primary" :style="[{'width':`${windowHeight}px` }]">{{ windowHeight }}</el-button> -->
      </div>
    </div>
    <div id="particles-js"></div>
  </div>
</template>
<script>
// import vue  from 'https://cdn.bootcss.com/vue/2.6.10/vue.js';
import { reactive, onMounted } from "vue";
import { logins } from "@/http/index.js";
import axios from "../http/axios";
export default {
  data() {
    return {
      fullscreen: false,
      loading: true,
      input1: "",
      input2: "",
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
    };
  },
  components: {},
  watch: {
    windowHeight(val) {
      let that = this;
      console.log("实时屏幕高度：", val, that.windowHeight);
    },
    windowWidth(val) {
      let that = this;
      console.log("实时屏幕宽度：", val, that.windowHeight);
    }
  },
  mounted() {
    var that = this;
    // that.$cookies.set("use_path_argument", "123", null, "/app/ki");
    // that.$cookie.setPath("/abc");

    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight;  // 高
        that.windowWidth = window.fullWidth; // 宽
      })()
    };
    // let shuint = ["88", "99"];
    // let urlas = 'https://wsq.szlh.org.cn/fds/group1/M00/00/48/wKgno2Qrwb2AMKHvAAB1cxhTDk4878.png'
    // let astoken='068b6e18147b9b1e2cf9e52372628772'
    // consloe.log()
  },
  methods: {
    keyup() {
      this.loginButon();
    },
    submitForm() {
      this.loginButon();
    },
    loginButon() {
      this.$cookies.set('admin','1','1')

      // let urls= 'https://cloud2.szkekj.com/iceplatform/api/login/getLoginByNameAndPwd'
      axios
        .get(
          // "http://47.106.126.250:18980/szjc/api/login/getLoginByNameAndPwd",
          // "https://cloud2.szkekj.com/iceplatform/api/login/getLoginByNameAndPwd",
          "/login/getLoginByNameAndPwd",
          {
            params: {
              //传入的参数
              username: this.input1,
              password: this.input2,
              t: Date.parse(new Date())
            }
          }
        )
        .then(response => {
          // response.set('Access-Control-Allow-Origin','*')
          if (response.code != 2000) {
            //     this.$notify({
            //   title: '成功',
            //   message: '这是一条成功的提示消息',
            //   type: 'success'
            // });
            this.$notify.error({
              title: "错误",
              message: "账号密码错误！"
            });
          } else {
            localStorage.clear()
            localStorage.setItem("sessionid", response.data.user.sessionid);
            localStorage.setItem("userCode", response.data.user.user.userCode);
            localStorage.setItem("officeCode", response.data.officeCode);
            var sessid = response.data.user.sessionid;
            // this.$cookies.set("jeesite.session.id", sessid,  path[domain[secure]],"3600s");
            this.$cookies.set("jeesite.session.id", sessid)   //return this
            // this.$cookies.set(keyName, value[, expireTimes[, path[, domain[, secure]]]])   //return this
            // this.$cookies.set("use_path_argument", "value", "1d", "/app");
            // this.$cookies.set("use_path_argument","123","1d","/app");  
            // let urpath = '/app'
            // this.$cookies.config('1d'[urpath])
            // this.$cookies.set("use_path_argument","value"); 
            // this.$cookies.set("use_path_argument","value","/app"); 
            // 'token=xxxyyyzzz; path=/admin';
            // let expireTimes = '1d';
            // let path = '/admie';
            // this.$cookies.config(expireTimes[paths, path])
            // this.$cookies.set("jeesite.session.id", sessid,'','/index','50',true,'','Lax','','')   //return this
            // this.$cookies.config([path,'/index']) 
            // this.$cookies.config("ud", '/path') 
            // Cookies.set('jeesite.session.id', sessid, {
            // 	path:'szjc'
            // })
            // localStorage.getItem("officeCode")
            this.$notify({
              title: "成功",
              message: "登录成功！",
              type: "success"
            });
            this.screen();
            // window.location.href='index.html';
            // this.$router.replace({
            //   path: "/index"
            // });
            this.$router.push({
              name: "index"
            });
          }
        })
      // this.screen();

      // this.$router.push({
      //       name: "index"
      //     });
      // const data={
      // username: this.input1,
      // password: this.input2
      //     };
      //     logins(data).then(res => {
      //     }).catch(err => {
      //     })
      // this.axios({
      //   method: "get",
      //   url: "http://47.106.126.250:18980/szjc/api/login/getLoginByNameAndPwd",
      //   data: {
      //          username: this.input1,
      // 					password: this.input2
      //   }
      // }).then(function(res) {
      //   // if (res.statusText == "OK") {
      //   // alert("登陆成功");
      //   // }
      // });
      // this.$axios.get("http://47.106.126.250:18980/szjc/api/login/getLoginByNameAndPwd",{
      //   params: {
      //       //传入的参数
      //       username: this.input1,
      // 					password: this.input2
      //     }
      // })
      // .then(response => {
      //   response.set('Access-Control-Allow-Origin','*')
      // });
    },
    screen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
  }
};
</script> 
<!-- 
    <link rel="stylesheet" type="text/css" href="css/reset.css" />
    <link rel="stylesheet" type="text/css" href="css/scanboardLogin.css" />
    <link rel="stylesheet" type="text/css" href="css/animsition.css" />
    <link href="https://cdn.bootcss.com/element-ui/2.8.2/theme-cha0lk/index.css" rel="stylesheet">
-->
<style>
@import "../store/scanboardLogin.css";

.boardLogin .inpGroup input {
  border: 0ch !important;
  background: inherit !important;
}

.el-input__wrapper {
  border: 0ch !important;
}
</style> 